module.exports = __webpack_public_path__ + "static/img/swyy.ca71f5cc.png";